module.exports = "/static/assets/f297977110c526792c36e9691b2310ce.png";